<template>
  <b-overlay :show="loading" class="row bg-white">
    <div class="col-12 mt-3">
      ¿Estás seguro de que quieres devolver el Lote Nº {{ batch.folio }}?
    </div>
    <div class="col-12 mt-3">
      <b-form id="form-message" data-vv-scope="form-message">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Motivo por el que se devuelve el lote"
              label-for="#"
            >
              <SelectValidate
                v-model="cause"
                :options="optionReturnType"
                name="return"
                v-validate="'required'"
                :danger="errors.has('form-message.return')"
                :danger-text="errors.first('form-message.return')"
                data-vv-as="motivo de devolución"
                :state="errors.has('form-message.return') ? false : null"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <vs-divider></vs-divider>
    <b-col
      cols="12"
      class="text-right"
    >
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        v-on:click="onReturn"
        data-cy="cancel-batch"
      >
        Si, Estoy seguro!
      </b-button>
    </b-col>
  </b-overlay>
</template>
<script>

import { returnBatch } from '@/febos/servicios/api/aduanas/batches.api';
import { optionsReturnPublished, optionsReturnInvoiced } from '@/febos/aduanas/batches/config/return';
import SelectValidate from '@/febos/chile/_vue/componentes/SelectValidate';
import { batchesCodeSates } from '@/febos/aduanas/batches/views/utils/constants';

export default {
  components: {
    SelectValidate
  },
  data() {
    return {
      loading: false,
      cause: '',
      optionsReturnPublished,
      optionsReturnInvoiced,
      batchesCodeSates
    };
  },
  computed: {
    optionReturnType() {
      if (this.batch.estado === this.batchesCodeSates.publicado) {
        return optionsReturnPublished;
      }
      return optionsReturnInvoiced;
    }
  },
  props: {
    batch: {
      type: Object,
      required: true
    }
  },
  methods: {
    async onReturn() {
      const isValid = await this.$validator.validateAll('form-message');
      if (!isValid) {
        return;
      }
      this.loading = true;
      try {
        await returnBatch({
          loteId: this.batch.loteId,
          message: this.cause
        });
        this.$emit('return');
      } finally {
        this.loading = false;
      }
    }
  },
  async created() {
    this.loading = false;
    this.cause = '';
  }
};
</script>
